export const toInt = (input: string) => parseInt(input, 10);
